<template>
  <div class="faqs__search relative">
    <input
      v-model="query"
      type="text"
      :placeholder="placeholder"
      @keyup="changed = true"
    >
    <button
      class="faqs__search-clear absolute"
      :disabled="query.length < 1"
      @click="clearSearchQuery"
    >
      <CloseIcon />
    </button>
  </div>
</template>

<script>
import { useFaqsStore } from '../pinia/FaqsStore'
import { mapState, mapActions } from 'pinia'

import CloseIcon from '../icons/close-icon'

export default {
  components: {
    CloseIcon
  },
  props: {
    placeholder: {
      type: String,
      default: 'Got a question in mind?'
    }
  },
  data () {
    return {
      query: '',
      changed: false
    }
  },
  computed: {
    ...mapState(useFaqsStore, [
      'searchQuery',
      'clearSearch'
    ]),
  },
  mounted () {
    setInterval(() => {
      if (this.changed) {
        this.updateSearchQuery(this.query)
        this.changed = false
      }
    }, 300)
  },
  methods: {
    ...mapActions(useFaqsStore, [
      'updateSearchQuery'
    ]),
    clearSearchQuery () {
      this.clearSearch()
      this.query = ''
      this.changed = false
    }
  },
}
</script>
